import React from 'react';
import BetbookPostReactions from '@/betbook/components/betbook-reactions/BetbookPostReactions';
import PrematchTipsContainerPending from '@/nikeone/components/PrematchTipsContainerPending';

function BetbookPostItemLoader() {
    return (
        <div className="betbook-post-item item-mb loader px-15 py-15">
            <div className="betbook-post-header mb-10 pb-15">
                <div className="header left">
                    <div className="avatar wave-animation" />
                    <div className="user-name wave-animation" />
                </div>
            </div>
            <div className="betbook-post-title wave-animation" />
            <div className="post-text wave-animation" />
            <div className="bet-box">
                <PrematchTipsContainerPending header />
            </div>
            <BetbookPostReactions commentsCount={0} customerComment={false} inspirationCount={0} viewCount={0} />
        </div>
    );
}

export default BetbookPostItemLoader;
